import Mutations from '../../../store/data/mutations'
export default {
  namespaced: true,
  state: {
    compliances: [],
    models: [],
    model: null,
    filterBy: "",
    drawer: false,
    loadingCompliances: false,
    loadingModels: false,
    contractorId: null,
    vehicleId: null,
    driverId: null,
    subjectId: null,
    dateRangeStart: null,
    dateRangeEnd: null,
    resourceType: null,
    resourceTypeObj: null,
    resourceTypes: [],
    showDetails: false,
    showInactive: false
  },
  mutations: Mutations,
}